// FBRInvoiceQRCode.js
import React from 'react';
import { QRCodeSVG } from 'qrcode.react';

const FBRInvoiceQRCode = ({ qrcode, size = 200 }) => {  // Changed to 'qrcode'
    if (!qrcode) {
        return <div style={{ color: 'red', padding: '10px' }}>No QR data available</div>;
    }

    return (
        <div className="qr-code-container" style={{display:'flex',justifyContent:'space-evenly' }}>
           <div>
             <img src="/images/fbrlogo.png" alt="FBR Logo" height={100} width={100}   />
           </div>
           <div>
            <QRCodeSVG
                value={qrcode}  // Changed to 'qrcode'
                size={size}
                level="H"
                includeMargin={false}
                style={{ 
                    width: '1in', 
                    height: '1in' 
                }}
            /></div>
        </div>
    );
};

export default FBRInvoiceQRCode;